import { SettingOutlined } from '@ant-design/icons-vue';
import AdminList from '@/views/permission/AdminList.vue';
import RoleList from '@/views/permission/RoleList.vue';

/**
 * 原「平台管理」葉頁（已併入系統營運側欄；路徑維持 /platform/*）
 * 操作紀錄改獨立父層，見 audit.js
 */
export const platformOpsLeafRoutes = [
    {
        path: '/platform/admin-list',
        component: AdminList,
        name: 'AdminList',
        meta: { title: '管理員管理' }
    },
    {
        path: '/platform/role-list',
        component: RoleList,
        name: 'RoleList',
        meta: { title: '角色管理' }
    },
    {
        path: '/platform/integrations',
        component: () => import('@/views/settings/ExternalIntegrations.vue'),
        name: 'ExternalIntegrations',
        meta: { title: '外部串接' }
    },
    {
        path: '/platform/finance-integration',
        component: () => import('@/views/settings/RagicIntegration.vue'),
        name: 'RagicIntegration',
        meta: { title: '財務資料串接', hidden: true }
    },
    {
        path: '/platform/ragic',
        redirect: { path: '/platform/integrations', query: { tab: 'finance' } },
        meta: { hidden: true }
    }
];

/** @deprecated 選單已廢除「平台管理」folder；僅供相容匯入 */
export const platformFolderRoute = {
    path: 'platform',
    name: 'Platform',
    redirect: '/platform/admin-list',
    meta: {
        title: '平台管理',
        icon: SettingOutlined,
        hidden: true
    },
    children: []
};

/** @deprecated 改用 platformOpsLeafRoutes + auditLogRoute */
export const platformChildrenRoutes = platformOpsLeafRoutes;

/** 舊路徑相容（不顯示於選單；掛在 Layout 同層） */
export const platformLegacyRedirects = [
    {
        path: '/permission/admin-list',
        redirect: '/platform/admin-list',
        meta: { hidden: true }
    },
    {
        path: '/permission/role-list',
        redirect: '/platform/role-list',
        meta: { hidden: true }
    },
    {
        path: 'permission',
        redirect: '/platform/admin-list',
        meta: { hidden: true }
    },
    {
        path: '/payment-api',
        redirect: '/platform/payment-api',
        meta: { hidden: true }
    },
    {
        path: 'settings',
        redirect: '/platform/payment-api',
        meta: { hidden: true }
    },
    {
        path: '/audit/logs',
        redirect: '/platform/audit-log',
        meta: { hidden: true }
    },
    {
        path: 'audit',
        redirect: '/platform/audit-log',
        meta: { hidden: true }
    },
    {
        // 舊「平台管理」入口
        path: '/platform',
        redirect: '/members',
        meta: { hidden: true }
    }
];
